var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-between align-items-center",
            },
            [
              _vm._t("header", function () {
                return [_c("text-header", [_vm._v("Спецификация")])]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("b-table", {
        staticClass: "table-atmo",
        class: { "is-table-invalid": _vm.v.$invalid || _vm.specErrors },
        attrs: {
          id: "my-table",
          fields: _vm.fields,
          items: _vm.items,
          "details-td-class": "py-1",
          "show-empty": "",
          small: "",
          responsive: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(index)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
            },
          },
          {
            key: "row-details",
            fn: function (data) {
              return [
                _vm.getPurchaseDeliverable(data.item.id).ktru_item
                  ? [
                      _c("p", [
                        _c("b", [_vm._v("Рег.номер ТРУ:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getPurchaseDeliverable(data.item.id).ktru_item
                                .reg_number
                            )
                        ),
                      ]),
                      _c("p", [
                        _c("b", [_vm._v("Группа ТРУ:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getPurchaseDeliverable(data.item.id).ktru_item
                                .ktru_group_name
                            )
                        ),
                      ]),
                      _c("p", [
                        _c("b", [_vm._v("Наименование:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getPurchaseDeliverable(data.item.id).ktru_item
                                .name
                            )
                        ),
                      ]),
                      _c("p", [
                        _c("b", [_vm._v("Тип:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.getPurchaseDeliverable(data.item.id).ktru_item
                                .type
                            )
                        ),
                      ]),
                      _vm.getPurchaseDeliverable(data.item.id).ktru_item
                        .okpd_code
                        ? _c("p", [
                            _c("b", [_vm._v("Код ОКПД2:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getPurchaseDeliverable(data.item.id)
                                    .ktru_item.okpd_code
                                )
                            ),
                          ])
                        : _vm._e(),
                      _vm.getPurchaseDeliverable(data.item.id).ktru_item
                        .country_of_origin_name
                        ? _c("p", [
                            _c("b", [_vm._v("Страна происхождения:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getPurchaseDeliverable(data.item.id)
                                    .ktru_item.country_of_origin_name
                                )
                            ),
                          ])
                        : _vm._e(),
                      _vm.getPurchaseDeliverable(data.item.id).ktru_item
                        .description
                        ? _c("p", [
                            _c("b", [_vm._v("Описание:")]),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getPurchaseDeliverable(data.item.id)
                                    .ktru_item.description
                                )
                            ),
                          ])
                        : _vm._e(),
                      _vm.getPurchaseDeliverable(data.item.id).ktru_item
                        .specs &&
                      _vm.getPurchaseDeliverable(data.item.id).ktru_item.specs
                        .length > 0
                        ? _c("p", [_c("b", [_vm._v("Характеристики:")])])
                        : _vm._e(),
                      _vm.getPurchaseDeliverable(data.item.id).ktru_item
                        .specs &&
                      _vm.getPurchaseDeliverable(data.item.id).ktru_item.specs
                        .length > 0
                        ? _c(
                            "ul",
                            _vm._l(
                              _vm.getPurchaseDeliverable(data.item.id).ktru_item
                                .specs,
                              function (spec, key) {
                                return _c("li", { key: "spec" + key }, [
                                  _c("span", { staticClass: "fw-600" }, [
                                    _vm._v(_vm._s(spec.name)),
                                  ]),
                                  _vm._v(": " + _vm._s(spec.value) + " "),
                                ])
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  : [_vm._v("—")],
              ]
            },
          },
          {
            key: "cell(specs)",
            fn: function (data) {
              return [
                _c("action-button-small", {
                  attrs: {
                    title:
                      (data.detailsShowing ? "Скрыть" : "Показать") +
                      " характеристики",
                    icon: data.detailsShowing ? "eye-slash" : "eye",
                  },
                  on: { click: data.toggleDetails },
                }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getPurchaseDeliverable(data.item.id).ktru_item.name
                    ) +
                    " "
                ),
              ]
            },
          },
          {
            key: "cell(okei)",
            fn: function (data) {
              return [
                _vm.getPurchaseDeliverable(data.item.id).ktru_item
                  .okei_local_symbol
                  ? [
                      _vm._v(
                        _vm._s(
                          _vm.getPurchaseDeliverable(data.item.id).ktru_item
                            .okei_local_symbol
                        )
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "cell(price)",
            fn: function (data) {
              return [
                _c("currency-input", {
                  staticClass:
                    "form-control fs-14 text-right currency-input mb-0",
                  class:
                    _vm.v.$each[data.index]?.price &&
                    !_vm.v.$each[data.index].price.$invalid
                      ? "is-valid"
                      : "is-invalid",
                  attrs: { currency: "RUB", locale: "ru" },
                  on: {
                    focus: function ($event) {
                      $event.target?.select()
                    },
                  },
                  model: {
                    value: data.item.price,
                    callback: function ($$v) {
                      _vm.$set(data.item, "price", $$v)
                    },
                    expression: "data.item.price",
                  },
                }),
              ]
            },
          },
          {
            key: "cell(vat)",
            fn: function (data) {
              return [
                _vm.withoutVat
                  ? [
                      _c("input", {
                        staticClass: "form-control fs-14 is-valid",
                        attrs: { disabled: "", type: "text", value: "Без НДС" },
                      }),
                    ]
                  : [
                      _c("v-select", {
                        class: {
                          "is-invalid": data.item.vat === null,
                          "d-inline-block": true,
                          "w-75": true,
                        },
                        attrs: {
                          "calculate-position": _vm.withPopper,
                          clearable: false,
                          options: _vm.vatDictionary,
                          reduce: (item) => item.id,
                          searchable: false,
                          "append-to-body": "",
                          label: "title",
                          placeholder: "НДС",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "no-options",
                              fn: function ({ search, searching, loading }) {
                                return [
                                  _vm._v(
                                    " Записей, соответствующих вашему запросу, не найдено."
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: data.item.vat,
                          callback: function ($$v) {
                            _vm.$set(data.item, "vat", $$v)
                          },
                          expression: "data.item.vat",
                        },
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.hover.top",
                              value: "Применить ко всем позициям спецификации",
                              expression:
                                "'Применить ко всем позициям спецификации'",
                              modifiers: { hover: true, top: true },
                            },
                          ],
                          staticClass: "d-inline-block pl-1",
                        },
                        [
                          _c("action-button-small", {
                            attrs: {
                              disabled: data.item.vat === null,
                              icon: "chevron-double-down",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.applyAll(data.item.vat)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
              ]
            },
          },
          {
            key: "bottom-row",
            fn: function () {
              return [
                _vm.v.$invalid || _vm.specErrors
                  ? _c(
                      "b-td",
                      {
                        staticClass: "align-text-top py-1 pl-1",
                        attrs: { colspan: "5" },
                      },
                      [
                        _c(
                          "b-form-invalid-feedback",
                          {
                            staticClass: "fs-14",
                            attrs: {
                              state: !_vm.v.$invalid && !_vm.specErrors,
                            },
                          },
                          [_vm._v(_vm._s(_vm.specErrorMessage))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "empty",
            fn: function () {
              return [
                _c("div", { staticClass: "w-100 text-center" }, [
                  _vm._v("Не добавлено позиций спецификации"),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }